import React from "react";

import logo from "../../assets/image.svg";

const CardCourses = () => {
  return (
    <div className="card-courses">
      <div className="card-courses-item">
        <div className="card-courses-item-right">
          <img src={logo} alt="logo" width={90} height={90} />
        </div>
        <div className="card-courses-item-body">
          <h5 className="course-name">Course Name</h5>
          <div className="course-info">
            <div className="item-body-courses">
              <div className="item-body-price course-item">
                <p>price</p>
                <p className="course-price">100 L.E</p>
              </div>
              <div className="item-body-instructor course-item">
                <p>Instructor</p>
                <p>Instructor name</p>
              </div>
            </div>
            <div className="item-body-courses">
              <div className="item-body-lessons course-item">
                <p>Lessons</p>
                <p>3</p>
              </div>
              <div className="item-body-quizzes course-item">
                <p>Quizzes</p>
                <p>2</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardCourses;
